import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { businessPlanQueryKeys } from 'services/businessPlan/businessPlan-qk';
import { businessToolFormQueryKeys } from 'services/businessToolForm/businessToolForm-qk';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlan, getBusinessToolStoreClear } from 'store/useBusinessToolStore/selectors';
import { useUserStore } from 'store/useUserStore';
import { getAuthUser } from 'store/useUserStore/selectors';

export const ClearBusinessToolObserver = () => {
  const authUser = useUserStore(getAuthUser);

  const queryClient = useQueryClient();

  const { uuid } = useBusinessToolStore(getBusinessPlan);
  const clearBusinessToolStore = useBusinessToolStore(getBusinessToolStoreClear);

  useEffect(() => {
    return () => {
      if (authUser && uuid) {
        clearBusinessToolStore();

        queryClient.resetQueries({ queryKey: businessPlanQueryKeys.businessPlan(uuid) });
        queryClient.resetQueries({ queryKey: businessToolFormQueryKeys.businessTool(uuid) });
      }
    };
  }, [uuid]);

  return null;
};
